var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import service from "@irati/identity/services/teams";
import authentication from "@irati/auth";
import { Select } from "@irati/ui/src/FormItem";
var TeamFilter = /** @class */ (function (_super) {
    __extends(TeamFilter, _super);
    function TeamFilter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            allTeams: []
        };
        _this.mapTeamToOption = function (teams) {
            return teams.map(function (team) {
                return { value: team.uuid, label: team.public_name };
            });
        };
        _this.handleChange = function (selectedTeams) {
            var onChange = _this.props.onChange;
            var teamUUIDList = selectedTeams.map(function (_a) {
                var value = _a.value;
                return value;
            });
            onChange(teamUUIDList);
        };
        return _this;
    }
    TeamFilter.prototype.componentDidMount = function () {
        var _this = this;
        var tenantId = authentication.userTenant().uuid;
        service.list(tenantId).then(function (allTeams) {
            _this.setState({ allTeams: allTeams });
        });
    };
    TeamFilter.prototype.render = function () {
        var value = this.props.value;
        var allTeams = this.state.allTeams;
        var selectedValues = value.split(",");
        var teamOptions = this.mapTeamToOption(allTeams);
        return (React.createElement(Select, { isMulti: true, name: "ReportingTeamFilter", label: "Teams", onChange: this.handleChange, value: teamOptions.filter(function (_a) {
                var optionValue = _a.value;
                return selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.includes(optionValue);
            }), options: teamOptions }));
    };
    return TeamFilter;
}(PureComponent));
export default TeamFilter;
